// extracted by mini-css-extract-plugin
module.exports = {"container":"PublicLayoutContainer_container__3MDPB","wide":"PublicLayoutContainer_wide__1p7H7","margins":"PublicLayoutContainer_margins__3_-I5"};